import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { colorTokens } from "./color-tokens";
import { transitions } from "./transition";
import { shadows } from "./shadows";
/**
 * Theme definition
 */

var breakpoints = {
  tablet: '768px',
  desktop: '992px'
};
var mediaQueries = {
  tablet: "@media screen and (min-width: ".concat(breakpoints.tablet, ")"),
  desktop: "@media screen and (min-width: ".concat(breakpoints.desktop, ")")
};
var spaces = {
  px: '1px',
  0: '0',
  2: '2px',
  4: '4px',
  6: '6px',
  8: '8px',
  12: '12px',
  16: '16px',
  24: '24px',
  32: '32px',
  48: '48px',
  64: '64px'
};
var zIndices = {
  negative: -1,
  base: 0,
  panel: 100,
  resizer: 110,
  auto: 'auto',
  overlay: 1300,
  sheet: 1350,
  modal: 1400,
  popover: 1500,
  toast: 1600,
  tooltip: 1700
};
export var baseTheme = {
  zIndices: zIndices,
  breakpoints: breakpoints,
  mediaQueries: mediaQueries,
  spaces: spaces,
  radii: {
    0: 0,
    4: '4px',
    6: '6px',
    8: '8px'
  },
  icons: {
    sm: '16px',
    md: '24px',
    lg: '32px'
  }
};
export var theme = _objectSpread(_objectSpread({}, baseTheme), {}, {
  colors: colorTokens,
  transitions: transitions,
  shadows: shadows
});